export default __webpack_public_path__ + "static/media/updatePassword@3x.a29ed69e.jpg";